<template>
  <div>
    <v-sheet
      v-if="label"
      rounded
      v-bind="$attrs"
      :color="color"
      :height="height"
      :width="width"
      :icon="icon"
    >
      <p :class="textProp">
        <v-icon :color="iconColor">{{ icon }}</v-icon>
        &nbsp;
        {{ label }}
      </p>
    </v-sheet>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    color: {
      type: String,
    },
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    iconColor: {
      type: String,
      default: "white",
    },
    height: {
      type: [String, Number],
      default: "30",
    },
    width: {
      type: [String, Number],
      default: "100%",
    },
    textProp: {
      type: String,
      default: "pa-1 text-body-2 white--text",
    },
  },
};
</script>

<style lang="scss" scoped></style>
